import { useRuntimeConfig } from 'nuxt/app';
import { AnalyticsBannerInteraction, EMPTY_ANALYTICS_BANNER_INTERACTION } from '~~/common/utils/AnalyticsBannerInteraction';
import {
  genBannerInteractionClickEventHandlers,
  sendBannerInteractionAnalytics,
  sendBannerViewInteraction,
} from '~~/common/utils/bannerInteractionAnalytics';

export default {
  props: {
    analyticsBannerInteraction: {
      type: [Object, Symbol],
      default: null,
      validator: !AnalyticsBannerInteraction || ((val) => {
        return (val === EMPTY_ANALYTICS_BANNER_INTERACTION) || AnalyticsBannerInteraction.isValid(val);
      }),
    },
    analyticsMeasurable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    genBannerInteractionClickEventHandlers () {
      return genBannerInteractionClickEventHandlers(this);
    },
    sendBannerInteractionAnalytics () {
      return sendBannerInteractionAnalytics(this);
    },
    sendBannerViewInteraction (payload) {
      const config = useRuntimeConfig();
      this.sendBannerViewInteractionTimeout = setTimeout(() => {
        clearTimeout(this.sendBannerViewInteractionTimeout);
        sendBannerViewInteraction(this, payload);
      }, (config.public.viewPromotionAnalyticsIntervalLength / 4));
    },
  },
  beforeUnmount () {
    clearTimeout(this.sendBannerViewInteractionTimeout);
  },
  data () {
    return {
      sendBannerViewInteractionTimeout: null,
    };
  },
};
